module.exports = __webpack_public_path__ + "img/9791185871479.a4334358.jpg";